import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../lib/api';
import { Crown, Loader2, CheckCircle, AlertCircle } from 'lucide-react';

export default function OwnerEntryPage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [status, setStatus] = useState('activating');
  const [message, setMessage] = useState('Activating owner access...');

  useEffect(() => {
    // If already logged in as owner, redirect
    if (user?.role === 'admin') {
      navigate('/feed', { replace: true });
      return;
    }

    const activateOwner = async () => {
      try {
        // Call owner-session to get token
        const res = await api.get('/auth/owner-session');
        
        if (res.data.token) {
          // Set token and owner device flag
          localStorage.setItem('sd_token', res.data.token);
          localStorage.setItem('sd_owner_device', 'true');
          
          setStatus('success');
          setMessage('Owner access activated!');
          
          // Redirect to feed after short delay
          setTimeout(() => {
            window.location.href = '/feed';
          }, 1000);
        } else {
          throw new Error('No token received');
        }
      } catch (err) {
        setStatus('error');
        setMessage('Owner activation failed. Please contact support.');
      }
    };

    activateOwner();
  }, [user, navigate]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center p-8">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold/20 mb-6">
          {status === 'activating' && <Loader2 size={32} className="text-gold animate-spin" />}
          {status === 'success' && <CheckCircle size={32} className="text-green-600" />}
          {status === 'error' && <AlertCircle size={32} className="text-red-600" />}
        </div>
        
        <h1 className="font-serif text-2xl mb-2 flex items-center justify-center gap-2">
          <Crown className="text-gold" size={24} />
          Owner Access
        </h1>
        
        <p className="text-muted-foreground text-sm">{message}</p>
        
        {status === 'success' && (
          <p className="text-xs text-green-600 mt-4">Redirecting to dashboard...</p>
        )}
      </div>
    </div>
  );
}
